<template>
  <div
    :ref="divRef"
    :class="divClass" />
</template>

<script>
  import JSONEditor from "jsoneditor"

  export default {
    name: "JsonTreeEditor",
    props: {
      originalJson: {
        type: Object,
        required: false,
        default: null,
      },
      modes: {
        type: Array[String],
        required: false,
        default: () => ["tree", "code"],
      },
      divRef: {
        type: String,
        required: false,
        default: "jsonEditorTree",
      },
      divClass: {
        type: String,
        required: false,
        default: "json-tree-editor",
      },
      readOnly: {
        type: Boolean,
        required: false,
        default: false,
      },
      emitOnChange: {
        type: String,
        required: false,
        default: 'json-change',
      },
    },
    data() {
      return {
        treeEditor: null,
        changedOverrideJSON: null,
      }
    },
    watch: {
      originalJson(newVal) {
        this.treeEditor.set(newVal)
      },
      changedOverrideJSON(newVal) {
        if (!this.readOnly) {
          this.$emit(this.emitOnChange, newVal)
        }
      },
    },
    async mounted() {
      this.treeEditor = new JSONEditor(this.$refs[this.divRef], {
        modes: this.modes,
        onEditable: () => !this.readOnly,
        onChangeText: (newText) => this.$emit('json-change', newText),
      })
    },
  }
</script>

<style scoped>

</style>